import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
    .object({
        name: yup.string().trim().required().label('Name'),
        email: yup.string().email().required().trim().label('Email'),
        phone: yup
            .string()
            .notRequired()
            .test('len', 'Phone number is not valid', val => val.length === 14 || val.length === 0)
            .nullable()
            .label('Phone'),
        message: yup.string().notRequired().trim().label('Message'),
    })
    .required();

const resolver = yupResolver(schema);

export { schema, resolver };